import { AppRouteGroup } from 'utils/routing/AppRouteGroup';

import {
  GRAD_PROGRAM_URL_SEGMENTS,
  INTERNSHIP_URL_SEGMENTS,
  JOB_URL_SEGMENTS,
  ORG_TYPE_URL_SEGMENTS,
  VOLOP_URL_SEGMENTS,
  combinedOrgTypeAndInternshipUrlSegments,
  combinedOrgTypeAndJobUrlSegments,
} from './mainRouteSegments';

export const mainRouteGroup = new AppRouteGroup({
  path: '/:lang',
  params: ['lang'],
});

export const mainHomeRoute = mainRouteGroup.route({ path: '' });

export const mainJobsRoute = mainRouteGroup.route({
  path: 'jobs',
  searchParams: ['q'],
});

export const mainOrgSegmentedRoutes = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeUrlSegment) => [
    mainRouteGroup.route({
      path: `${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${orgTypeUrlSegment}/:orgIdDashSlug`,
      params: ['orgIdDashSlug'],
    }),
  ],
);

export const mainJobSegmentedRoutes = [
  ...JOB_URL_SEGMENTS,
  ...combinedOrgTypeAndJobUrlSegments,
].flatMap((jobUrlSegment) => [
  mainRouteGroup.route({
    path: `${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
  mainRouteGroup.route({
    path: `amp/${jobUrlSegment}/:jobIdDashSlug`,
    params: ['jobIdDashSlug'],
  }),
]);

export const mainInternshipSegmentedRoutes = [
  ...INTERNSHIP_URL_SEGMENTS,
  ...combinedOrgTypeAndInternshipUrlSegments,
].flatMap((internshipUrlSegment) => [
  mainRouteGroup.route({
    path: `${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
  mainRouteGroup.route({
    path: `amp/${internshipUrlSegment}/:internshipIdDashSlug`,
    params: ['internshipIdDashSlug'],
  }),
]);

export const mainVolopSegmentedRoutes = VOLOP_URL_SEGMENTS.flatMap(
  (volopUrlSegment) => [
    mainRouteGroup.route({
      path: `${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${volopUrlSegment}/:volopIdDashSlug`,
      params: ['volopIdDashSlug'],
    }),
  ],
);

export const mainGradProgramSegmentedRoutes = GRAD_PROGRAM_URL_SEGMENTS.flatMap(
  (gradProgramUrlSegment) => [
    mainRouteGroup.route({
      path: `${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
    mainRouteGroup.route({
      path: `amp/${gradProgramUrlSegment}/:programIdDashSlug`,
      params: ['programIdDashSlug'],
    }),
  ],
);
